import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["MemberCard"] */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/components_simple/MemberCard.tsx");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-agnes.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-alexandre.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-alexandreannic.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-aline.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-charles.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-emmanuel.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-franck.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-gregoire.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-guillaumedegerando.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-guillaumerossmann.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-hakimsedoud.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-ingridgodefroy.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-jerome.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-jules.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-julien.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-magali.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-nathanielrichand.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-nicolas.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-pierre-olivier.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-quentinkurtz.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-saidsedoud.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-thomas.png");
;
import(/* webpackMode: "eager" */ "/home/bas/app_b87cda9f-4054-4354-b92f-82f57d04f7dd/website/src/img/avatars/avatar-valentine.png");
